import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const LeadViewDtls = ({ LeadMainData }) => {
  const classes = useStyles();
  const [LeadStatus, setLeadStatus] = useState("");
  const [LeadNo, setLeadNo] = useState("");
  const [LeadDate, setLeadDate] = useState("");
  const [ContactName, setContactName] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [Industry, setIndustry] = useState("");
  const [CurrencyID,setCurrencyID] = useState("");
  const [Phone, setPhone] = useState("");
  const [NoOfEmployees, setNoOfEmployees] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Rating, setRating] = useState("");
  const [Designation, setDesignation] = useState("");
  const [Department, setDepartment] = useState("");
  const [Address, setAddress] = useState("");
  const [City, setCity] = useState("");
  const [PINCode, setPINCode] = useState("");
  const [Country, setCountry] = useState("");
  const [State, setState] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [CreatedOn, setCreatedOn] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");
  const [ModifiedOn, setModifiedOn] = useState("");

  useEffect(() => {
    if (LeadMainData !== undefined && LeadMainData.length > 0) {
      setLeadNo(LeadMainData[0].LeadNo);
      setLeadStatus(LeadMainData[0].LeadStatus);
      setContactName(LeadMainData[0].ContactName);
      setLeadDate(LeadMainData[0].LeadDate); 
      setDepartment(LeadMainData[0].Department);
      setDesignation(LeadMainData[0].Designation);
      setCompanyName(LeadMainData[0].CompanyName);
      setNoOfEmployees(LeadMainData[0].NoOfEmployees);
      setIndustry(LeadMainData[0].Industry);
      setCurrencyID(LeadMainData[0].CurrencyID);
      setRating(LeadMainData[0].Rating);
      setPhone(LeadMainData[0].Phone);
      setMobile(LeadMainData[0].Mobile);
      setAddress(
        LeadMainData[0].Address1 + " " + LeadMainData[0].Address2
      );
      setCountry(LeadMainData[0].Country);
      setCity(LeadMainData[0].City);
      setState(LeadMainData[0].State);
      setPINCode(LeadMainData[0].PINCode);
      setCreatedBy(LeadMainData[0].CreatedBy);
      setModifiedBy(LeadMainData[0].ModifiedBy);
      setCreatedOn(LeadMainData[0].CreatedOn);
      setModifiedOn(LeadMainData[0].ModifiedOn);
    }
  }, [LeadMainData]);

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          textDecorationColor: "#0096FF",
          textDecorationThickness: 5,
          fontSize: 20,
          fontWeight: "bold",
        }}
      >
        DETAILS
      </div>
      <Grid spacing={1} container style={{ marginTop: 7, marginLeft: 7 }}>
        <Grid item xs={12} className={classes.headerCmn}>
          Lead Information
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Lead No:</div>
          <div>{LeadNo}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Lead Status:</div>
          <div>{LeadStatus}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Contact Name:</div>
          <div>{ContactName}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Lead Date:</div>
          <div>{LeadDate}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Department:</div>
          <div>{Department}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Designation:</div>
          <div>{Designation}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Company Name:</div>
          <div>{CompanyName}</div>
        </Grid>
        {/* <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Currency:</div>
          <div>{CurrencyID}</div>
        </Grid> */}
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Industry:</div>
          <div>{Industry}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Rating:</div>
          <div>{Rating}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Phone:</div>
          <div>{Phone}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Mobile:</div>
          <div>{Mobile}</div>
        </Grid>
        <Grid item xs={12} className={classes.headerCmn}>
          Address Information
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Address:</div>
          <div>{Address}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>City:</div>
          <div>{City}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Country:</div>
          <div>{Country}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>State:</div>
          <div>{State}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>PIN Code:</div>
          <div>{PINCode}</div>
        </Grid>
        <Grid item xs={12} className={classes.headerCmn}>
          System Information
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Created By:</div>
          <div>{CreatedBy}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Last Modified By:</div>
          <div>{ModifiedBy}</div>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    marginRight: 16,
    //margin:"0.3rem",
    marginLeft: -7,
    fontWeight: "bold",
  },
}));

export default LeadViewDtls;
